import { render } from "./ProjectConfirmationView.vue?vue&type=template&id=34f5947a&scoped=true"
import script from "./ProjectConfirmationView.vue?vue&type=script&lang=js"
export * from "./ProjectConfirmationView.vue?vue&type=script&lang=js"

import "./ProjectConfirmationView.vue?vue&type=style&index=0&id=34f5947a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f5947a"]])

export default __exports__